export enum AnnotationType {
    UNKNOWN,
    UNFORMATTED_TEXT,
    VALUE,
    MARKER,
}

export interface IMeasure {
    name: string;
    value?: number;
    udM: string;
}

export interface IAnnotation extends IMeasure {
    mappedName: string;
    detail: string;
    type: AnnotationType;
    markers: Array<number>;
}

export interface IMeasureCategory {
    id: string;
    description: string;
    order: number;
}

export interface ICustomMeasure extends IMeasure {
    id: string;
    idEcgMeasure: any;
    internalUid: string;
    category: IMeasureCategory;
    isCalculated: boolean;
    isPrintable: boolean;
    isHighlighted: boolean;
    isManualModified: boolean;
    formulaDescription: string;
    formula: string;
    decimalDigit: number;
}
